import { setItemStorage, getItemStorage, removeItemStorage } from "@/core/helpers/storage";

/** Legacy key — API tokens must never live in localStorage (P5-01). */
const ID_TOKEN_KEY = "id_token" as string;
/** Non-sensitive SPA flag only (not the Sanctum token). */
const AUTH_FLAG_KEY = "sl_auth" as string;

const purgeLegacyToken = (): void => {
  removeItemStorage(ID_TOKEN_KEY);
  try {
    window.localStorage.removeItem(ID_TOKEN_KEY);
  } catch {
    // ignore
  }
};

/**
 * @deprecated Token is server-session only. Returns null always.
 */
export const getToken = (): string | null => {
  purgeLegacyToken();
  return null;
};

/** True when this tab believes a Laravel FE session is authenticated. */
export const hasAuth = (): boolean => {
  purgeLegacyToken();
  return !!getItemStorage(AUTH_FLAG_KEY) || !!getItemStorage("usr");
};

/**
 * Mark SPA as authenticated. Does not store any API token.
 */
export const saveToken = (_token?: string): void => {
  purgeLegacyToken();
  setItemStorage(AUTH_FLAG_KEY, "1");
  try {
    window.localStorage.setItem("sl_auth_state", String(Date.now()));
  } catch {
    // ignore
  }
};

/**
 * Clear SPA auth flag and any legacy id_token.
 */
export const destroyToken = (): void => {
  purgeLegacyToken();
  removeItemStorage(AUTH_FLAG_KEY);
  try {
    window.localStorage.setItem("sl_auth_state", "0");
  } catch {
    // ignore
  }
};

export default { getToken, hasAuth, saveToken, destroyToken };
